// File: adult-landing.js
// Import Cumulo
import Cumulo from '../modules/cumulo.js';
import tbxHandleNewsFeed from '../sections/news-feed.js';

class HomeRenderer extends Cumulo {
    onEnterCompleted() {
        tbxHandleNewsFeed();
    }
}

// Don`t forget to export your renderer
export default HomeRenderer;